import { render, staticRenderFns } from "./learning_side.vue?vue&type=template&id=01fa6246&scoped=true&"
import script from "./learning_side.vue?vue&type=script&lang=js&"
export * from "./learning_side.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fa6246",
  null
  
)

export default component.exports